import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 73 73"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "72",
      height: "72",
      x: ".5",
      y: ".205",
      fill: "#000",
      "fill-opacity": ".4",
      rx: "36"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M27.5 20.455v31.5l24.75-15.75z"
    }, null, -1)
  ]))]))
}
export default { render: render }